import { AxiosInstance } from '@price-for-profit/micro-services';
import { Category, CategoryList } from 'shared/types';

export interface IParameterService {
    getCategories(): Promise<CategoryList[]>;
    getCategory(categoryId: string): Promise<Category>;
    updateCategory(category: Category): Promise<Category>;
    uploadParameters(): Promise<void>;
}

export class ParameterService implements IParameterService {
    private baseUrl: string = '/api/parameter/';
    constructor(private httpClient: AxiosInstance) {}
    async getCategories(): Promise<CategoryList[]> {
        const { data } = await this.httpClient.get<CategoryList[]>(this.baseUrl);
        return data;
    }
    async getCategory(categoryId: string): Promise<Category> {
        const { data } = await this.httpClient.get<Category>(`${this.baseUrl}${categoryId}/`);
        return data;
    }

    async updateCategory(category: Category): Promise<Category> {
        const { data } = await this.httpClient.put<Category>(`${this.baseUrl}${category.key}/`, category);
        return data;
    }
    async uploadParameters(): Promise<void> {
        const { data } = await this.httpClient.get(`${this.baseUrl}upload/`);
        return data;
    }
}
